import { Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { TranscribeComponent } from '@xmedical/transcribe';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

@Component({
  selector: 'xmed-multi-line-text-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule,
    TranscribeComponent
  ],
  templateUrl: './multi-line-text-field-renderer.component.html',
  styleUrl: './multi-line-text-field-renderer.component.scss'
})
export class MultiLineTextFieldRendererComponent {
  private editorService = inject(ReportControlEditorService);

  control = input.required<ReportControl>();

  onTextReceived(text: string): void {
    this.control().value += text;
    this.editorService.triggerEvent();
  }

  onValueChanges(): void {
    this.editorService.triggerEvent();
  }
}
